/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormHelperText, SxProps, TextField, Theme } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import FormErrors from "../formErrors";

export function InputFormItem(props) {
  const {
    label,
    name,
    hint,
    type,
    placeholder,
    autoFocus,
    autoComplete,
    required,
    externalErrorMessage,
    disabled,
    startAdornment,
    endAdornment,
    maxLength,
    variant,
    multiline,
    rows,
    id,
    margin,
    fullWidth,
    size,
    styles = { backgroundColor: "transparent", color: "black" },
  } = props;

  const {
    control,
    setValue,
    register,
    watch,
    getValues,
    formState: { touchedFields, isSubmitted, errors },
  } = useFormContext();

  const errorMessage = FormErrors.errorMessage(
    name,
    errors,
    touchedFields,
    isSubmitted,
    externalErrorMessage
  );

  const FieldName = useWatch({
    control,
    name: name,
  });
  const [Focus, SetFocus] = useState(false);
  const [sValueText, setValueText] = useState<string>(watch(name));

  const maxLengthText: SxProps = {
    "::after": {
      content: maxLength
        ? `"${sValueText ? sValueText.length : 0}/${maxLength}"`
        : '""',
      position: "absolute",
      bottom: "2px",
      right: "10px",
      color: "#989898",
      fontSize: "10px",
    },
  };

  useEffect(() => {
    if( maxLength != null && watch(name) == null )
    {
      setValueText("")
    }
  }, [watch(name)])
  

  return (
    <>
      <TextField
        name={name}
        type={type}
        label={label}
        required={required}
        inputRef={register(name).ref}
        {...register(name)}
        onChange={(e) => {
          if(maxLength)
          {
            setValueText(e.target.value || "")
          }
          props.onChange && props.onChange(e.target.value);
          setValue(name, e.target.value, { shouldValidate: true });
        }}
        onBlur={(event) => {
          SetFocus(false);
          props.onBlur && props.onBlur(event);
        }}
        onKeyPress={(event) => {
          props.onKeyPress && props.onKeyPress(event);
        }}
        onKeyDown={(event) => {
          props.onKeyDown && props.onKeyDown(event);
        }}
        onKeyUp={(event) => {
          props.onKeyPress && props.onKeyPress(event);
        }}
        onFocus={() => {
          SetFocus(true);
        }}
        margin={margin}
        fullWidth={fullWidth != undefined ? fullWidth : true}
        // variant={ disabled ? "standard" :variant ? variant : "outlined"}
        variant={variant ? variant : disabled ? undefined : "outlined"}
        size={size}
        placeholder={placeholder || undefined}
        autoFocus={autoFocus || undefined}
        autoComplete={autoComplete || "off"}
        error={Boolean(errorMessage)}
        InputProps={startAdornment ? { startAdornment } : { endAdornment }}
        inputProps={{
          maxLength: maxLength ? maxLength : null,
          name,
        }}
        InputLabelProps={{
          shrink: FieldName || Focus ? true : false,
        }}
        disabled={disabled}
        style={styles || undefined}
        multiline={multiline || undefined}
        rows={rows || undefined}
        id={id || undefined}
        sx={{
          "label.MuiInputLabel-shrink": {
            backgroundColor: "rgba(255,255,255)",
            top: "0px",
          },
          ".MuiInputLabel-outlined": {
            top: "0px",
          },
          ".MuiInputLabel-asterisk": {
            color: "red"
          },
          ".Mui-disabled": {
            backgroundColor: "#f1f1f1",
            color: "#000000"

          }
          , ...maxLengthText
        }}
        
      />
      {errors && errors[name] ? (
        <FormHelperText sx={{ color: "red" }}>
          {errors[name].message}
        </FormHelperText>
      ) : null}
    </>
  );
}

InputFormItem.defaultProps = {
  type: "text",
  size: "small",
  required: false,
};

InputFormItem.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  type: PropTypes.string,
  label: PropTypes.string,
  hint: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  prefix: PropTypes.string,
  placeholder: PropTypes.string,
  onKeyDown: PropTypes.any,
  onKeyPress: PropTypes.any,
  onKeyUp: PropTypes.any,
  onBlur: PropTypes.any,
  autoComplete: PropTypes.string,
  textSecondary: PropTypes.bool,
  externalErrorMessage: PropTypes.string,
  onChange: PropTypes.func,
  startAdornment: PropTypes.any,
  endAdornment: PropTypes.any,
  maxLength: PropTypes.number,
  variant: PropTypes.string,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  id: PropTypes.string,
  size: PropTypes.string,
  margin: PropTypes.string,
  fullWidth: PropTypes.bool,
  styles: PropTypes.object,
};

export default InputFormItem;